import { FiX } from 'react-icons/fi'
import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { IconButton } from '@material-ui/core'
import { is } from '../../MediaQuery'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'
import { SearchInputContainer, SearchInputInput } from './styled'

const SearchInput: FunctionComponent<ISearchInputProps & IWithSize> = ({
  hasClear = true,
  term,
  onTermChange,
  inputRef,
  size = 1,
}) => {
  const [t] = useTranslation()
  const isMobile = is.mobile()

  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    onTermChange(e.currentTarget.value)
  }

  function clear() {
    onTermChange('')
  }

  return (
    <SearchInputContainer>
      <SearchInputInput
        size={size}
        placeholder={t('search_title')}
        onChange={onChange}
        value={term}
        fullWidth={true}
        disableUnderline={true}
        ref={inputRef}
      />
      {hasClear && term.length > 0 && (
        <IconButton
          style={{
            backgroundColor: 'transparent',
            cursor: 'pointer',
            opacity: 0.8,
            padding: `${12 * size}px`,
            position: 'absolute',
            right: isMobile ? `${8 * size}px` : `${size}px`,
            top: isMobile ? `${9 * size}px` : `${-size}px`,
          }}
          onClick={clear}
        >
          <FiX size={18 * size} />
        </IconButton>
      )}
    </SearchInputContainer>
  )
}

export default SearchInput

export interface ISearchInputProps {
  hasClear?: boolean
  term: string
  onTermChange?: (string) => void
  inputRef?: any
}
